import { useMemo } from 'react';
import useFirestoreCollection from '../hooks/useFirestoreCollection';
import MasonryGallery from './MasonryGallery';

export default function Portfolio() {
  const { data: galleryItems } = useFirestoreCollection('gallery', {
    orderBy: { field: 'createdAt', direction: 'desc' },
  });

  const items = useMemo(
    () =>
      galleryItems.map((item) => ({
        src: item.src,
        caption: item.caption || item.alt || 'Proyecto de galería',
        alt: item.alt || item.caption || 'Proyecto de galería',
      })),
    [galleryItems]
  );


  return (
    <section className="py-20 relative bg-[#F8FAFC] dark:bg-slate-950 overflow-hidden" id="portfolio">
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-6 mb-10">
          <div>
            <h3 className="text-3xl md:text-4xl font-display font-black text-secondary dark:text-slate-100 tracking-tight">
              Galería
            </h3>
            <p className="mt-3 text-slate-500 dark:text-slate-300 text-sm max-w-xl leading-relaxed">
             .
            </p>
          </div>
          <p className="text-slate-500 dark:text-slate-300 text-sm font-light text-right">
            Click para abrir · Swipe para cambiar · Rueda para zoom.
          </p>
        </div>

        {items.length === 0 ? (
          <div className="rounded-3xl border border-dashed border-slate-300 dark:border-slate-700 p-12 text-center bg-white dark:bg-slate-900 text-slate-600 dark:text-slate-300">
            <p className="text-lg font-semibold mb-3">Aún no hay imágenes en la galería.</p>
            <p>Agrega imágenes desde el panel administrativo para que aparezcan en esta sección.</p>
          </div>
        ) : (
          <MasonryGallery items={items} />
        )}
      </div>
    </section>
  );
}
